import React, { useEffect, useState } from 'react';

// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports

import { BackButton } from './buttons/back-button';
import { ExtraButton } from './buttons/extra-button';
import { NextButton } from './buttons/next-button';
import { SubmitButton } from './buttons/submit-button';
import { FooterButtonsWrapper, FooterInfoTextWrapper, FooterWrapper, HorizontalDivider } from './styled';
export const Footer = ({
  currentStepConfig,
  testId,
  contentSize,
  currentStep
}) => {
  const {
    formId,
    nextButtonOnClick,
    extraButtonOnClick,
    footerInfoText,
    backButtonOnClick,
    isSubmissionLoading,
    backButtonText,
    backButtonAppearance,
    extraButtonText,
    extraButtonAppearance,
    isExtraButtonDisabled,
    nextButtonText,
    nextButtonAppearance,
    isNextButtonDisabled
  } = currentStepConfig;
  const [previousStep, setPreviousStep] = useState(currentStep);
  const [isFooterInfoTextUpdated, setIsFooterInfoTextUpdated] = useState(false);
  useEffect(() => {
    if (currentStep !== previousStep) {
      setIsFooterInfoTextUpdated(false);
    } else {
      setIsFooterInfoTextUpdated(true);
    }
    setPreviousStep(currentStep);
  }, [currentStep, previousStep]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HorizontalDivider, {
    "data-testid": `${testId}-footer-divider`,
    role: "presentation"
  }), /*#__PURE__*/React.createElement(FooterWrapper, {
    "data-testid": `${testId}-footer`,
    contentSize: contentSize
  }, /*#__PURE__*/React.createElement(FooterInfoTextWrapper, {
    "data-testid": `${testId}-footer-info-text`,
    role: isFooterInfoTextUpdated ? 'status' : undefined,
    "aria-atomic": isFooterInfoTextUpdated ? 'true' : undefined
  }, footerInfoText), /*#__PURE__*/React.createElement(FooterButtonsWrapper, null, backButtonOnClick && /*#__PURE__*/React.createElement(BackButton, {
    backButtonOnClick: backButtonOnClick,
    isSubmissionLoading: isSubmissionLoading,
    backButtonText: backButtonText,
    backButtonAppearance: backButtonAppearance,
    testId: testId
  }), extraButtonOnClick && /*#__PURE__*/React.createElement(ExtraButton, {
    extraButtonText: extraButtonText,
    extraButtonOnClick: extraButtonOnClick,
    extraButtonAppearance: extraButtonAppearance,
    isExtraButtonDisabled: isExtraButtonDisabled,
    isSubmissionLoading: isSubmissionLoading,
    testId: testId
  }), !!nextButtonOnClick && !formId && /*#__PURE__*/React.createElement(NextButton, {
    nextButtonText: nextButtonText,
    nextButtonOnClick: nextButtonOnClick,
    nextButtonAppearance: nextButtonAppearance,
    isNextButtonDisabled: isNextButtonDisabled,
    isSubmissionLoading: isSubmissionLoading,
    testId: testId
  }), !!formId && /*#__PURE__*/React.createElement(SubmitButton, {
    nextButtonText: nextButtonText,
    nextButtonOnClick: nextButtonOnClick,
    nextButtonAppearance: nextButtonAppearance,
    isNextButtonDisabled: isNextButtonDisabled,
    isSubmissionLoading: isSubmissionLoading,
    formId: formId,
    testId: testId
  }))));
};